import { Components, Theme } from "@mui/material";

export const MuiTab: Components<Omit<Theme, "MuiTab">>["MuiTab"] = {
  defaultProps: {
    sx: {
      textTransform: "none",
    },
  },
};
